module.exports = __webpack_public_path__ + "static/media/logo.164fe019.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 760
// module chunks = 0